import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/service.index';
import { Order } from '../order';

@Component({
  selector: 'info-dialog',
  templateUrl: 'info.component.html',
  styleUrls: ['./info.component.css'],
})
export class InfoDialog {

  logs;

  constructor(
    public dialogRef: MatDialogRef<InfoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.logs = this.data;

  }

}